import { render, staticRenderFns } from "./GoodsListNew.vue?vue&type=template&id=16bc7a64&"
import script from "./GoodsListNew.vue?vue&type=script&lang=js&"
export * from "./GoodsListNew.vue?vue&type=script&lang=js&"
import style0 from "./GoodsListNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports